// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#removeFromMtpTableModal .disabled {
  color: #d0d0d0;
}
#removeFromMtpTableModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#removeFromMtpTableModal .table {
  border: 1px solid #dee2e6;
}
#removeFromMtpTableModal .table td {
  border-right: 1px solid #dee2e6;
  border-top: none;
  white-space: nowrap;
  vertical-align: middle;
  width: 100%;
}
#removeFromMtpTableModal .table td div {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
#removeFromMtpTableModal .table tr:nth-child(even) {
  background-color: #f9f9f9;
}
#removeFromMtpTableModal .table thead th {
  border-bottom: 1px solid #dee2e6;
  white-space: nowrap;
  border-right: 1px solid #dee2e6;
}
#removeFromMtpTableModal .table label {
  margin-bottom: 0;
}
#removeFromMtpTableModal .btn-link {
  color: #5b5b5b;
  font-weight: bold;
}
#removeFromMtpTableModal .btn-link:hover {
  text-decoration: none;
  color: #5a5a5a;
}
#removeFromMtpTableModal .btn-link:focus {
  text-decoration: none;
}
#removeFromMtpTableModal .btn-secondary {
  background-color: #b4b4b4;
  box-shadow: none !important;
  border: none;
}
#removeFromMtpTableModal .btn-primary {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
@media (min-width: 2024px) {
#removeFromMtpTableModal #confirmation-modal-label {
    font-size: 3.2rem;
}
}
#removeFromMtpTableModal .invalid-feedback {
  display: block;
}
@media (min-width: 2024px) {
#removeFromMtpTableModal .invalid-feedback span {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#removeFromMtpTableModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 2024px) {
#removeFromMtpTableModal .modal-dialog .input-group input {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#removeFromMtpTableModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}
#removeFromMtpTableModal {
  /* Hide the browser's default checkbox */
}
#removeFromMtpTableModal .container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
#removeFromMtpTableModal {
  /* Create a custom checkbox */
}
#removeFromMtpTableModal .checkmark {
  position: absolute;
  margin-left: -14px;
  margin-top: 1px;
  height: 20px;
  width: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 4px;
}
#removeFromMtpTableModal {
  /* When the checkbox is checked, add a blue background */
}
#removeFromMtpTableModal .container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}
#removeFromMtpTableModal {
  /* Create the checkmark/indicator (hidden when not checked) */
}
#removeFromMtpTableModal .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
#removeFromMtpTableModal {
  /* Show the checkmark when checked */
}
#removeFromMtpTableModal .container input:checked ~ .checkmark:after {
  display: block;
}
#removeFromMtpTableModal {
  /* Style the checkmark/indicator */
}
#removeFromMtpTableModal .container .checkmark:after {
  left: 6px;
  top: 0px;
  width: 5px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
